import { render } from "./draft.vue?vue&type=template&id=d761e328&scoped=true"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"

import "./draft.vue?vue&type=style&index=0&id=d761e328&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d761e328"]])

export default __exports__